import { merge, pathOr } from 'ramda';
import {
  INFO_FAIL, INFO_SUCCESS, INFO_REQUEST,
  DATA_REQUEST, DATA_SUCCESS, DATA_FAIL,
  VERSIONS_REQUEST, VERSIONS_FAIL, VERSIONS_SUCCESS, SET_SUPER_RIGHTS, SET_LOGGING_OUT
} from 'src/store/actions/userActions';

const initialState = {
  data: {},
  versions: {},
  fetching: false,
  loaded: false,
  errors: [],
  versionsLoaded: false,
  userData: {},
  userDataFetching: false,
  isSuperRightsActive: false,
  loggingOut: false
};

export const selectUserId = pathOr(null, ['userInfo', 'data', 'UserId']);

const userInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case INFO_REQUEST:
      return merge(state, { fetching: true });
    case INFO_SUCCESS:
      return merge(state, { fetching: false, data: action.userInfo, loaded: true });
    case INFO_FAIL:
      return merge(state, { fetching: false, loaded: true });
    case DATA_REQUEST:
      return merge(state, { userDataFetching: true });
    case DATA_SUCCESS:
      return merge(state, { userDataFetching: false, userData: action.userData });
    case DATA_FAIL:
      return merge(state, { userDataFetching: false });
    case VERSIONS_REQUEST:
      return merge(state, { fetching: true });
    case VERSIONS_FAIL:
      return merge(state, { fetching: false, loaded: true, versionsLoaded: true });
    case VERSIONS_SUCCESS:
      return merge(state, {
        fetching: false,
        versions: action.versions[0],
        loaded: true,
        versionsLoaded: true
      });
    case SET_SUPER_RIGHTS:
      return merge(state, { isSuperRightsActive: action.isSuper });
    case SET_LOGGING_OUT:
      return merge(state, { loggingOut: action.loggingOut });
    default:
      return state;
  }
};

export default userInfoReducer;
